import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BrokenSection } from './components/BrokenSection';
import { BrandsSection } from './components/BrandsSection';
import { StepsSection } from './components/StepsSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="2rit3h6j5vwqy">
      <div className="min-h-screen w-full bg-white font-sans text-slate-900 antialiased" data-id="element-1" data-mp="2mm2luerpkt3f">
        <Header data-id="element-2" data-mp="31aqfuglwour9" />
        <main data-id="element-3" data-mp="31b8jvzet8d9q">
          <Hero data-id="element-4" data-mp="31bs2licab5ot" />
          <BrandsSection data-id="element-5" data-mp="31bi8bik7icdb" />
          <BrokenSection data-id="element-6" data-mp="31ctetq51dy84" />
          <StepsSection data-id="element-7" data-mp="2wk9zanmsgt0o" />
          <CtaSection data-id="element-8" data-mp="2wiyx2s8zrtbo" />
        </main>
        <Footer data-id="element-9" data-mp="2whx9xpepbgdl" />
      </div>
    </LanguageProvider>;
}